export const objectValidator = (validatorsMap) => (o) => (o &&
    Object.entries(validatorsMap).flatMap(([key, validator]) => validator(o[key]))) ||
    [];
//# sourceMappingURL=objectValidator.js.map